import SvgIcon from '@mui/material/SvgIcon';

const LeftSvgIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

export default LeftSvgIcon;
